// vue-jquery-ui-plugin.js
import $ from "jquery";
import "jquery-ui/ui/widgets/draggable"; // Import the specific jQuery UI component
import "jquery-ui/ui/widgets/resizable";
import "jquery-ui-rotatable/jquery.ui.rotatable";
import "jquery-ui-touch-punch";

const jQueryUIPlugin = {
  install(Vue) {
    Vue.prototype.$jquery = $;

    Vue.directive("draggable", {
      bind(el) {
        $(el).draggable();
      },
    });

    Vue.directive("resizable", {
      bind(el) {
        $(el).resizable();
      },
    });

    Vue.directive("rotatable", {
      bind(el) {
        $(el).rotatable();
      },
    });

  },
};

export default jQueryUIPlugin;
